import { HeaderItem, HeaderItemType } from '../../../pages/main/header/types/header';

export const homeHeaderItemsConfig: HeaderItem[] = [
  {
    id: 'lang-selector',
    type: HeaderItemType.LanguageSelector,
    ariaLabel: 'Select Language',
  },
];
